import React, { useState } from 'react'
import { useMount } from 'react-use'
import { setInfoBreadcrumb } from 'lib/sentry'
import LoadingIndicator from 'components/LoadingIndicator'
import ErrorComponent from './ErrorComponent'

const ChunkError = ({ originalError }) => {
    const [displayOriginalError, setDisplayOriginalError] = useState(false)

    useMount(() => {
        setInfoBreadcrumb('Chunk error occurred. Attempt to check application version and reload before displaying generic error...')
        window.__mv_appVersionHandler.fetchVersionAndReloadIfChanged()
            .then(reloadApp => {
                if (!reloadApp) setDisplayOriginalError(true)
            })
            .catch((e) => setDisplayOriginalError(e))
    })

    return displayOriginalError ? (
        <ErrorComponent error={originalError} isHandledChunkError />
    ) : (
        <LoadingIndicator />
    )
}

export default ChunkError
